<div class="lp-wrapper">
  <div *ngIf="loading" class="lp-status">Loading…</div>
  <div *ngIf="!loading && errorMsg" class="lp-status lp-error">{{ errorMsg }}</div>

  <ngx-charts-bar-horizontal-2d
    *ngIf="!loading && !errorMsg"
    [results]="chartData"
    [view]="viewsize"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="false"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
  [xAxisLabel]="xAxisLabel"
  [yAxisLabel]="yAxisLabel"
  [trimXAxisTicks]="true"
  [trimYAxisTicks]="true"
    [yAxisTickFormatting]="formatTheme"
    [xAxisTickFormatting]="formatCount">
  </ngx-charts-bar-horizontal-2d>
</div>
